





































































































import { Vue, Component, Emit, Prop, Watch, Ref } from 'vue-property-decorator';
import { types } from '../../api_types';
import T from '../../lang';
import * as ui from '../../ui';
import * as Markdown from '@/third_party/js/pagedown/Markdown.Editor.js';
import * as markdown from '../../markdown';

import omegaup_problemMarkdown from './Markdown.vue';
import user_Username from '../user/Username.vue';

const markdownConverter = new markdown.Converter({
  preview: true,
});

@Component({
  components: {
    'omegaup-user-username': user_Username,
    'omegaup-markdown': omegaup_problemMarkdown,
  },
})
export default class ProblemStatementEdit extends Vue {
  @Ref() readonly markdownButtonBar!: HTMLDivElement;
  @Ref() readonly markdownInput!: HTMLTextAreaElement;
  @Prop() alias!: string;
  @Prop() title!: string;
  @Prop() source!: string;
  @Prop({ default: null }) problemsetter!: types.ProblemsetterInfo;
  @Prop() statement!: types.ProblemStatement;
  @Prop() markdownType!: string;
  @Prop({ default: true }) showEditControls!: boolean;
  @Prop({ default: () => ['es', 'en', 'pt'] }) languages!: string[];

  T = T;
  commitMessage = T.updateStatementsCommitMessage;
  currentLanguage = this.statement.language;
  currentMarkdown = this.statement.markdown;
  errors: string[] = [];
  statements: types.Statements = {};
  markdownEditor: Markdown.Editor | null = null;

  mounted(): void {
    this.markdownEditor = new Markdown.Editor(markdownConverter.converter, '', {
      panels: {
        buttonBar: this.markdownButtonBar,
        preview: null,
        input: this.markdownInput,
      },
    });
    this.markdownEditor.run();
  }

  getLanguageNameText(language: string): string {
    switch (language) {
      case 'en':
        return T.statementLanguageEn;
      case 'es':
        return T.statementLanguageEs;
      case 'pt':
        return T.statementLanguagePt;
      default:
        return '';
    }
  }

  @Watch('statement')
  onStatementChange(newStatement: types.ProblemStatement): void {
    this.currentLanguage = newStatement.language;
    this.currentMarkdown = newStatement.markdown;
  }

  @Watch('currentLanguage')
  onCurrentLanguageChange(newLanguage: string, oldLanguage: string): void {
    if (oldLanguage) this.statements[oldLanguage] = this.currentMarkdown;
    this.$emit(
      'update-markdown-contents',
      this.statements,
      newLanguage,
      this.currentMarkdown,
    );
  }

  @Emit('update:statement')
  @Watch('currentMarkdown')
  onCurrentMarkdownChange(newMarkdown: string): types.ProblemStatement {
    return {
      images: this.statement.images,
      language: this.statement.language,
      sources: this.statement.sources,
      markdown: newMarkdown,
    };
  }

  onSubmit(e: Event) {
    this.errors = [];
    this.statements[this.currentLanguage] = this.currentMarkdown;
    if (this.commitMessage) {
      return;
    }
    this.errors.push('message');
    ui.error(T.editFieldRequired);
    e.preventDefault();
  }
}
